export default __webpack_public_path__ + "static/media/logo-branca.89fadc60.svg";